// extracted by mini-css-extract-plugin
module.exports = {"HCP_Search":"Search_HCP_Search__1IHV1","HCP_Search_Details":"Search_HCP_Search_Details__3tC0r"};